function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { extend } from "../../../shared/utils/extend.js";

var buildURLQuery = function buildURLQuery(src, obj) {
  var url = new URL(src);
  var params = new URLSearchParams(url.search);
  var rez = new URLSearchParams();

  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(params), _toConsumableArray(Object.entries(obj))); _i2 < _arr2.length; _i2++) {
    var _ref3 = _arr2[_i2];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];

    // Youtube
    if (key === "t") {
      rez.set("start", parseInt(value));
    } else {
      rez.set(key, value);
    }
  } // Convert to 'foo=1&bar=2&baz=3'


  rez = rez.toString(); // Vimeo
  // https://vimeo.zendesk.com/hc/en-us/articles/360000121668-Starting-playback-at-a-specific-timecode

  var matches = src.match(/#t=((.*)?\d+s)/);

  if (matches) {
    rez += "#t=".concat(matches[1]);
  }

  return rez;
};

var defaults = {
  // General options for any video content (Youtube, Vimeo, HTML5 video)
  video: {
    autoplay: true,
    ratio: 16 / 9
  },
  // Youtube embed parameters
  youtube: {
    autohide: 1,
    fs: 1,
    rel: 0,
    hd: 1,
    wmode: "transparent",
    enablejsapi: 1,
    html5: 1
  },
  // Vimeo embed parameters
  vimeo: {
    hd: 1,
    show_title: 1,
    show_byline: 1,
    show_portrait: 0,
    fullscreen: 1
  },
  // HTML5 video parameters
  html5video: {
    tpl: "<video class=\"fancybox__html5video\" playsinline controls controlsList=\"nodownload\" poster=\"{{poster}}\">\n  <source src=\"{{src}}\" type=\"{{format}}\" />Sorry, your browser doesn't support embedded videos.</video>",
    format: ""
  }
};
export var Html = /*#__PURE__*/function () {
  function Html(fancybox) {
    _classCallCheck(this, Html);

    this.fancybox = fancybox;

    for (var _i3 = 0, _arr3 = ["onInit", "onReady", "onCreateSlide", "onRemoveSlide", "onSelectSlide", "onUnselectSlide", "onRefresh", // For communication with iframed video (youtube/vimeo)
    "onMessage"]; _i3 < _arr3.length; _i3++) {
      var methodName = _arr3[_i3];
      this[methodName] = this[methodName].bind(this);
    }

    this.events = {
      init: this.onInit,
      ready: this.onReady,
      "Carousel.createSlide": this.onCreateSlide,
      "Carousel.removeSlide": this.onRemoveSlide,
      "Carousel.selectSlide": this.onSelectSlide,
      "Carousel.unselectSlide": this.onUnselectSlide,
      "Carousel.refresh": this.onRefresh
    };
  }
  /**
   * Check if each gallery item has type when fancybox starts
   */


  _createClass(Html, [{
    key: "onInit",
    value: function onInit() {
      var _iterator = _createForOfIteratorHelper(this.fancybox.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slide = _step.value;
          this.processType(slide);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Set content type for the slide
     * @param {Object} slide
     */

  }, {
    key: "processType",
    value: function processType(slide) {
      // Add support for `new Fancybox({items : [{html : 'smth'}]});`
      if (slide.html) {
        slide.src = slide.html;
        slide.type = "html";
        delete slide.html;
        return;
      }

      var src = slide.src || "";
      var type = slide.type || this.fancybox.options.type,
          rez = null;

      if (src && typeof src !== "string") {
        return;
      }

      if (rez = src.match(/(?:youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
        var params = buildURLQuery(src, this.fancybox.option("Html.youtube"));
        var videoId = encodeURIComponent(rez[1]);
        slide.videoId = videoId;
        slide.src = "https://www.youtube-nocookie.com/embed/".concat(videoId, "?").concat(params);
        slide.thumb = slide.thumb || "https://i.ytimg.com/vi/".concat(videoId, "/mqdefault.jpg");
        slide.vendor = "youtube";
        type = "video";
      } else if (rez = src.match(/^.+vimeo.com\/(?:\/)?([\d]+)(.*)?/)) {
        var _params = buildURLQuery(src, this.fancybox.option("Html.vimeo"));

        var _videoId = encodeURIComponent(rez[1]);

        slide.videoId = _videoId;
        slide.src = "https://player.vimeo.com/video/".concat(_videoId, "?").concat(_params);
        slide.vendor = "vimeo";
        type = "video";
      } else if (rez = src.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) {
        slide.src = "//maps.google.".concat(rez[1], "/?ll=").concat((rez[2] ? rez[2] + "&z=" + Math.floor(rez[3]) + (rez[4] ? rez[4].replace(/^\//, "&") : "") : rez[4] + "").replace(/\?/, "&"), "&output=").concat(rez[4] && rez[4].indexOf("layer=c") > 0 ? "svembed" : "embed");
        type = "map";
      } else if (rez = src.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) {
        slide.src = "//maps.google.".concat(rez[1], "/maps?q=").concat(rez[2].replace("query=", "q=").replace("api=1", ""), "&output=embed");
        type = "map";
      } // Guess content type


      if (!type) {
        if (src.charAt(0) === "#") {
          type = "inline";
        } else if (rez = src.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) {
          type = "html5video";
          slide.format = slide.format || "video/" + (rez[1] === "ogv" ? "ogg" : rez[1]);
        } else if (src.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)) {
          type = "image";
        } else if (src.match(/\.(pdf)((\?|#).*)?$/i)) {
          type = "pdf";
        }
      }

      slide.type = type || this.fancybox.option("defaultType", "image");

      if (type === "html5video" || type === "video") {
        slide.video = extend({}, this.fancybox.option("Html.video"), slide.video);

        if (slide._width && slide._height) {
          slide.ratio = parseFloat(slide._width) / parseFloat(slide._height);
        } else {
          slide.ratio = slide.ratio || slide.video.ratio || defaults.video.ratio;
        }
      }
    }
    /**
     * Start loading content when Fancybox is ready
     */

  }, {
    key: "onReady",
    value: function onReady() {
      var _this = this;

      this.fancybox.Carousel.slides.forEach(function (slide) {
        if (slide.$el) {
          _this.setContent(slide);

          if (slide.index === _this.fancybox.getSlide().index) {
            _this.playVideo(slide);
          }
        }
      });
    }
    /**
     * Process `Carousel.createSlide` event to create image content
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onCreateSlide",
    value: function onCreateSlide(fancybox, carousel, slide) {
      if (this.fancybox.state !== "ready") {
        return;
      }

      this.setContent(slide);
    }
    /**
     * Retrieve and set slide content
     * @param {Object} slide
     */

  }, {
    key: "loadInlineContent",
    value: function loadInlineContent(slide) {
      var $content;

      if (slide.src instanceof HTMLElement) {
        $content = slide.src;
      } else if (typeof slide.src === "string") {
        var tmp = slide.src.split("#", 2);
        var id = tmp.length === 2 && tmp[0] === "" ? tmp[1] : tmp[0];
        $content = document.getElementById(id);
      }

      if ($content) {
        if (slide.type === "clone" || $content.$placeHolder) {
          $content = $content.cloneNode(true);
          var attrId = $content.getAttribute("id");
          attrId = attrId ? "".concat(attrId, "--clone") : "clone-".concat(this.fancybox.id, "-").concat(slide.index);
          $content.setAttribute("id", attrId);
        } else {
          var $placeHolder = document.createElement("div");
          $placeHolder.classList.add("fancybox-placeholder");
          $content.parentNode.insertBefore($placeHolder, $content);
          $content.$placeHolder = $placeHolder;
        }

        this.fancybox.setContent(slide, $content);
      } else {
        this.fancybox.setError(slide, "{{ELEMENT_NOT_FOUND}}");
      }
    }
    /**
     * Makes AJAX request and sets response as slide content
     * @param {Object} slide
     */

  }, {
    key: "loadAjaxContent",
    value: function loadAjaxContent(slide) {
      var fancybox = this.fancybox;
      var xhr = new XMLHttpRequest();
      fancybox.showLoading(slide);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (fancybox.state === "ready") {
            fancybox.hideLoading(slide);

            if (xhr.status === 200) {
              fancybox.setContent(slide, xhr.responseText);
            } else {
              fancybox.setError(slide, xhr.status === 404 ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}");
            }
          }
        }
      };

      var data = slide.ajax || null;
      xhr.open(data ? "POST" : "GET", slide.src);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhr.send(data);
      slide.xhr = xhr;
    }
    /**
     * Creates iframe as slide content, preloads if needed before displaying
     * @param {Object} slide
     */

  }, {
    key: "loadIframeContent",
    value: function loadIframeContent(slide) {
      var _this2 = this;

      var fancybox = this.fancybox;
      var $iframe = document.createElement("iframe");
      $iframe.className = "fancybox__iframe";
      $iframe.setAttribute("id", "fancybox__iframe_".concat(fancybox.id, "_").concat(slide.index));
      $iframe.setAttribute("allow", "autoplay; fullscreen");
      $iframe.setAttribute("scrolling", "auto");
      slide.$iframe = $iframe;

      if (slide.type !== "iframe" || slide.preload === false) {
        $iframe.setAttribute("src", slide.src);
        this.fancybox.setContent(slide, $iframe);
        this.resizeIframe(slide);
        return;
      }

      fancybox.showLoading(slide);
      var $content = document.createElement("div");
      $content.style.visibility = "hidden";
      this.fancybox.setContent(slide, $content);
      $content.appendChild($iframe);

      $iframe.onerror = function () {
        fancybox.setError(slide, "{{IFRAME_ERROR}}");
      };

      $iframe.onload = function () {
        fancybox.hideLoading(slide);
        var isFirstLoad = false;

        if (!$iframe.isReady) {
          $iframe.isReady = true;
          isFirstLoad = true;
        }

        if (!$iframe.src.length) {
          return;
        }

        $iframe.parentNode.style.visibility = "";

        _this2.resizeIframe(slide);

        if (isFirstLoad) {
          fancybox.revealContent(slide);
        }
      };

      $iframe.setAttribute("src", slide.src);
    }
    /**
     * Set CSS max/min width/height properties of the content to have the correct aspect ratio
     * @param {Object} slide
     */

  }, {
    key: "setAspectRatio",
    value: function setAspectRatio(slide) {
      var $content = slide.$content;
      var ratio = slide.ratio;

      if (!$content) {
        return;
      }

      var width = slide._width;
      var height = slide._height;

      if (ratio || width && height) {
        Object.assign($content.style, {
          width: width && height ? "100%" : "",
          height: width && height ? "100%" : "",
          maxWidth: "",
          maxHeight: ""
        });
        var maxWidth = $content.offsetWidth;
        var maxHeight = $content.offsetHeight;
        width = width || maxWidth;
        height = height || maxHeight; // Resize to fit

        if (width > maxWidth || height > maxHeight) {
          var maxRatio = Math.min(maxWidth / width, maxHeight / height);
          width = width * maxRatio;
          height = height * maxRatio;
        } // Recheck ratio


        if (Math.abs(width / height - ratio) > 0.01) {
          if (ratio < width / height) {
            width = height * ratio;
          } else {
            height = width / ratio;
          }
        }

        Object.assign($content.style, {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        });
      }
    }
    /**
     * Adjust the width and height of the iframe according to the content dimensions, or defined sizes
     * @param {Object} slide
     */

  }, {
    key: "resizeIframe",
    value: function resizeIframe(slide) {
      var $iframe = slide.$iframe;

      if (!$iframe) {
        return;
      }

      var width_ = slide._width || 0;
      var height_ = slide._height || 0;

      if (width_ && height_) {
        slide.autoSize = false;
      }

      var $parent = $iframe.parentNode;
      var parentStyle = $parent && $parent.style;

      if (slide.preload !== false && slide.autoSize !== false && parentStyle) {
        try {
          var compStyles = window.getComputedStyle($parent),
              paddingX = parseFloat(compStyles.paddingLeft) + parseFloat(compStyles.paddingRight),
              paddingY = parseFloat(compStyles.paddingTop) + parseFloat(compStyles.paddingBottom);

          var _document = $iframe.contentWindow.document,
              $html = _document.getElementsByTagName("html")[0],
              $body = _document.body; // Allow content to expand horizontally


          parentStyle.width = ""; // Get rid of vertical scrollbar

          $body.style.overflow = "hidden";
          width_ = width_ || $html.scrollWidth + paddingX;
          parentStyle.width = "".concat(width_, "px");
          $body.style.overflow = "";
          parentStyle.flex = "0 0 auto";
          parentStyle.height = "".concat($body.scrollHeight, "px");
          height_ = $html.scrollHeight + paddingY;
        } catch (error) {//
        }
      }

      if (width_ || height_) {
        var newStyle = {
          flex: "0 1 auto"
        };

        if (width_) {
          newStyle.width = "".concat(width_, "px");
        }

        if (height_) {
          newStyle.height = "".concat(height_, "px");
        }

        Object.assign(parentStyle, newStyle);
      }
    }
    /**
     * Process `Carousel.onRefresh` event,
     * trigger iframe autosizing and set content aspect ratio for each slide
     * @param {Object} fancybox
     * @param {Object} carousel
     */

  }, {
    key: "onRefresh",
    value: function onRefresh(fancybox, carousel) {
      var _this3 = this;

      carousel.slides.forEach(function (slide) {
        if (!slide.$el) {
          return;
        }

        if (slide.$iframe) {
          _this3.resizeIframe(slide);
        }

        if (slide.ratio) {
          _this3.setAspectRatio(slide);
        }
      });
    }
    /**
     * Process `Carousel.onCreateSlide` event to set content
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "setContent",
    value: function setContent(slide) {
      if (!slide || slide.isDom) {
        return;
      }

      switch (slide.type) {
        case "html":
          this.fancybox.setContent(slide, slide.src);
          break;

        case "html5video":
          this.fancybox.setContent(slide, this.fancybox.option("Html.html5video.tpl").replace(/\{\{src\}\}/gi, slide.src).replace("{{format}}", slide.format || slide.html5video && slide.html5video.format || "").replace("{{poster}}", slide.poster || slide.thumb || ""));
          break;

        case "inline":
        case "clone":
          this.loadInlineContent(slide);
          break;

        case "ajax":
          this.loadAjaxContent(slide);
          break;

        case "pdf":
        case "video":
        case "map":
          slide.preload = false;

        case "iframe":
          this.loadIframeContent(slide);
          break;
      }

      if (slide.ratio) {
        this.setAspectRatio(slide);
      }
    }
    /**
     * Process `Carousel.onSelectSlide` event to start video
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onSelectSlide",
    value: function onSelectSlide(fancybox, carousel, slide) {
      if (fancybox.state === "ready") {
        this.playVideo(slide);
      }
    }
    /**
     * Attempts to begin playback of the media
     * @param {Object} slide
     */

  }, {
    key: "playVideo",
    value: function playVideo(slide) {
      if (slide.type === "html5video" && slide.video.autoplay) {
        try {
          var $video = slide.$el.querySelector("video");

          if ($video) {
            var promise = $video.play();

            if (promise !== undefined) {
              promise.then(function () {// Autoplay started
              })["catch"](function (error) {
                // Autoplay was prevented.
                $video.muted = true;
                $video.play();
              });
            }
          }
        } catch (err) {}
      }

      if (slide.type !== "video" || !(slide.$iframe && slide.$iframe.contentWindow)) {
        return;
      } // This function will be repeatedly called to check
      // if video iframe has been loaded to send message to start the video


      var poller = function poller() {
        if (slide.state === "done" && slide.$iframe && slide.$iframe.contentWindow) {
          var command;

          if (slide.$iframe.isReady) {
            if (slide.video && slide.video.autoplay) {
              if (slide.vendor == "youtube") {
                command = {
                  event: "command",
                  func: "playVideo"
                };
              } else {
                command = {
                  method: "play",
                  value: "true"
                };
              }
            }

            if (command) {
              slide.$iframe.contentWindow.postMessage(JSON.stringify(command), "*");
            }

            return;
          }

          if (slide.vendor === "youtube") {
            command = {
              event: "listening",
              id: slide.$iframe.getAttribute("id")
            };
            slide.$iframe.contentWindow.postMessage(JSON.stringify(command), "*");
          }
        }

        slide.poller = setTimeout(poller, 250);
      };

      poller();
    }
    /**
     * Process `Carousel.onUnselectSlide` event to pause video
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onUnselectSlide",
    value: function onUnselectSlide(fancybox, carousel, slide) {
      if (slide.type === "html5video") {
        try {
          slide.$el.querySelector("video").pause();
        } catch (error) {}

        return;
      }

      var command = false;

      if (slide.vendor == "vimeo") {
        command = {
          method: "pause",
          value: "true"
        };
      } else if (slide.vendor === "youtube") {
        command = {
          event: "command",
          func: "pauseVideo"
        };
      }

      if (command && slide.$iframe && slide.$iframe.contentWindow) {
        slide.$iframe.contentWindow.postMessage(JSON.stringify(command), "*");
      }

      clearTimeout(slide.poller);
    }
    /**
     * Process `Carousel.onRemoveSlide` event to do clean up
     * @param {Object} fancybox
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onRemoveSlide",
    value: function onRemoveSlide(fancybox, carousel, slide) {
      // Abort ajax request if exists
      if (slide.xhr) {
        slide.xhr.abort();
        slide.xhr = null;
      } // Unload iframe content if exists


      if (slide.$iframe) {
        slide.$iframe.onload = slide.$iframe.onerror = null;
        slide.$iframe.src = "//about:blank";
        slide.$iframe = null;
      } // Clear inline content


      var $content = slide.$content;

      if (slide.type === "inline" && $content) {
        $content.classList.remove("fancybox__content");

        if ($content.style.display !== "none") {
          $content.style.display = "none";
        }
      }

      if (slide.$closeButton) {
        slide.$closeButton.remove();
        slide.$closeButton = null;
      }

      var $placeHolder = $content && $content.$placeHolder;

      if ($placeHolder) {
        $placeHolder.parentNode.insertBefore($content, $placeHolder);
        $placeHolder.remove();
        $content.$placeHolder = null;
      }
    }
    /**
     * Process `window.message` event to mark video iframe element as `ready`
     * @param {Object} e - Event
     */

  }, {
    key: "onMessage",
    value: function onMessage(e) {
      try {
        var data = JSON.parse(e.data);

        if (e.origin === "https://player.vimeo.com") {
          if (data.event === "ready") {
            var _iterator2 = _createForOfIteratorHelper(document.getElementsByClassName("fancybox__iframe")),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var $iframe = _step2.value;

                if ($iframe.contentWindow === e.source) {
                  $iframe.isReady = 1;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } else if (e.origin === "https://www.youtube-nocookie.com") {
          if (data.event === "onReady") {
            document.getElementById(data.id).isReady = 1;
          }
        }
      } catch (ex) {}
    }
  }, {
    key: "attach",
    value: function attach() {
      this.fancybox.on(this.events);
      window.addEventListener("message", this.onMessage, false);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.fancybox.off(this.events);
      window.removeEventListener("message", this.onMessage, false);
    }
  }]);

  return Html;
}(); // Expose defaults

Html.defaults = defaults;